import { render } from "./SquadDutyBreaks.vue?vue&type=template&id=90ff32d8"
import script from "./SquadDutyBreaks.vue?vue&type=script&lang=js"
export * from "./SquadDutyBreaks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__